import * as React from 'react';

import ClosedSvg from '../../assets/closed.svg';

import styles from './onboarding-graphic-closed.module.css';

export class OnboardingGraphicClosed extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.closed}>
                <ClosedSvg />
            </div>
        );
    }
}
